var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dtGetTicketsLoading,
              expression: "dtGetTicketsLoading"
            }
          ],
          ref: "spinner",
          staticStyle: {
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            "z-index": "200",
            background: "rgba(255, 255, 255, .95)"
          },
          attrs: { "align-start": "", "justify-center": "" }
        },
        [
          _c("div", { staticStyle: { "margin-top": "200px" } }, [
            _c("div", { staticClass: "primary--text" }, [
              _c("div", { staticClass: "lds-roller" }, [
                _c("div"),
                _c("div"),
                _c("div"),
                _c("div"),
                _c("div"),
                _c("div"),
                _c("div"),
                _c("div")
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("Patientez SVP ...")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "pb-3": "", row: "", wrap: "" } },
        [
          _vm.coIsAppointment
            ? _c(
                "v-flex",
                {
                  staticClass: "form-section xs12",
                  class: [_vm.coIsAppointment ? "md4" : "md6"]
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _vm.coIsAppointment
                        ? [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-layout",
                                  { staticClass: "title--text-custom" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "primary--text" },
                                      [_vm._v("1")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "secondary--text" },
                                      [_vm._v(".")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("h1", { staticClass: "primary--text" }, [
                                  _vm._v("Qui ?")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isAppointmentTicketRequired
                              ? _c(
                                  "div",
                                  { staticClass: "mx-2" },
                                  [
                                    _c("v-switch", {
                                      attrs: {
                                        color: "primary",
                                        label: _vm.$t(
                                          _vm.lblSetting
                                            .agendaAppointmentWithoutTicket
                                        ),
                                        disabled: _vm.isUpdating
                                      },
                                      model: {
                                        value: _vm.isWithoutTicket,
                                        callback: function($$v) {
                                          _vm.isWithoutTicket = $$v
                                        },
                                        expression: "isWithoutTicket"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isWithoutTicket
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "base-control-label-vertical",
                                      {
                                        attrs: {
                                          required: "",
                                          label: _vm.$t(
                                            _vm.lblSetting.agendaSidebarBlock
                                          )
                                        }
                                      },
                                      [
                                        _c("base-multi-select", {
                                          attrs: {
                                            options: _vm.coBlockOptions,
                                            "item-value": "id",
                                            icon: "icon icon-blocks",
                                            "item-text": "name",
                                            "return-object": false,
                                            multiple: false,
                                            rules: _vm.dtRules.blockRules,
                                            fetch: _vm.handleGetBlocks
                                          },
                                          on: { change: _vm.handleBlockChange },
                                          model: {
                                            value: _vm.appointmentFkBlock,
                                            callback: function($$v) {
                                              _vm.appointmentFkBlock = $$v
                                            },
                                            expression: "appointmentFkBlock"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.appointmentFkBlock
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "base-control-label-vertical",
                                              {
                                                attrs: {
                                                  label: _vm.$tc(
                                                    _vm.lblSetting
                                                      .agendaWelcoming,
                                                    2
                                                  )
                                                }
                                              },
                                              [
                                                _c("base-multi-select", {
                                                  attrs: {
                                                    rules: [],
                                                    "item-value": "id",
                                                    "return-object": false,
                                                    options: _vm.AWTwelcomings,
                                                    loading: _vm.isLoading,
                                                    disabled: _vm.isLoading,
                                                    fetch:
                                                      _vm.searchAWTwelcomings
                                                  },
                                                  model: {
                                                    value: _vm.coWelcomings,
                                                    callback: function($$v) {
                                                      _vm.coWelcomings = $$v
                                                    },
                                                    expression: "coWelcomings"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "base-control-label-vertical",
                                              {
                                                attrs: {
                                                  label: _vm.$tc(
                                                    _vm.lblSetting
                                                      .agendaParticipant,
                                                    2
                                                  )
                                                }
                                              },
                                              [
                                                _c("base-multi-select", {
                                                  attrs: {
                                                    rules: [],
                                                    "item-value": "id",
                                                    "return-object": false,
                                                    options:
                                                      _vm.AWTparticipants,
                                                    loading: _vm.isLoading,
                                                    disabled: _vm.isLoading,
                                                    fetch:
                                                      _vm.searchAWTparticipants
                                                  },
                                                  model: {
                                                    value: _vm.coParticipants,
                                                    callback: function($$v) {
                                                      _vm.coParticipants = $$v
                                                    },
                                                    expression: "coParticipants"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "base-control-label-vertical",
                                              {
                                                attrs: {
                                                  label: _vm.$tc(
                                                    _vm.lblSetting
                                                      .agendaIndependentContractorUpdate,
                                                    2
                                                  )
                                                }
                                              },
                                              [
                                                _c("v-switch", {
                                                  staticClass: "mt-0 mb-2 pt-0",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      _vm.lblSetting
                                                        .labelMaintenanceshowAllContractor
                                                    ),
                                                    "hide-details": "",
                                                    color: "primary"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.showAllContactors,
                                                    callback: function($$v) {
                                                      _vm.showAllContactors = $$v
                                                    },
                                                    expression:
                                                      "showAllContactors"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("base-multi-select", {
                                                  attrs: {
                                                    rules: [],
                                                    "item-value": "id",
                                                    "return-object": false,
                                                    options: _vm.AWTcontrators,
                                                    loading: _vm.isLoading,
                                                    disabled: _vm.isLoading,
                                                    fetch:
                                                      _vm.searchAWTcontrators
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.coIndependentContractors,
                                                    callback: function($$v) {
                                                      _vm.coIndependentContractors = $$v
                                                    },
                                                    expression:
                                                      "coIndependentContractors"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.self
                                      ? _c(
                                          "base-control-label-vertical",
                                          {
                                            attrs: {
                                              required: "",
                                              label: _vm.$t(
                                                _vm.lblSetting.agendaTicket
                                              )
                                            }
                                          },
                                          [
                                            _c("base-autocomplete", {
                                              attrs: {
                                                clearable: !_vm.isUpdating,
                                                "default-text":
                                                  _vm.dtDefaultText,
                                                error: _vm.dtRequireTicket,
                                                rules: _vm.dtRules.ticketRules,
                                                items: _vm.coTickets,
                                                "item-value": "id",
                                                "return-object": true,
                                                "item-text": "subject",
                                                "on-fetch-remote":
                                                  _vm.handeGetTicketsAutocomplete,
                                                disabled: _vm.isUpdating
                                              },
                                              on: {
                                                change: _vm.handleTicketChange
                                              },
                                              model: {
                                                value: _vm.appointmentFkTicket,
                                                callback: function($$v) {
                                                  _vm.appointmentFkTicket = $$v
                                                },
                                                expression:
                                                  "appointmentFkTicket"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "base-control-label-vertical",
                                      {
                                        attrs: {
                                          required:
                                            _vm.dtIndependentContractorResources
                                              .length > 0,
                                          label: _vm.$tc(
                                            _vm.lblSetting
                                              .agendaIndependentContractor,
                                            2
                                          )
                                        }
                                      },
                                      [
                                        _c("base-multi-select", {
                                          attrs: {
                                            rules:
                                              _vm.dtRules
                                                .independentContractorRules,
                                            disabled: _vm.canAddIC,
                                            "return-object": false,
                                            options:
                                              _vm.dtIndependentContractorResources
                                          },
                                          model: {
                                            value: _vm.coIndependentContractors,
                                            callback: function($$v) {
                                              _vm.coIndependentContractors = $$v
                                            },
                                            expression:
                                              "coIndependentContractors"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.self
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "application__button--no-decoration",
                                                attrs: {
                                                  href: "javascript:void(0);"
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleRedirectToTicket
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .agendaRedirectTo
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "base-control-label-vertical",
                                      {
                                        attrs: {
                                          label: _vm.$tc(
                                            _vm.lblSetting.agendaWelcoming,
                                            2
                                          )
                                        }
                                      },
                                      [
                                        _vm.coDeclarants
                                          ? _c("base-multi-select", {
                                              attrs: {
                                                "item-value": "id",
                                                "return-object": false,
                                                options: _vm.coDeclarants,
                                                fetch: _vm.handleSearchWelcoming
                                              },
                                              model: {
                                                value: _vm.coWelcomings,
                                                callback: function($$v) {
                                                  _vm.coWelcomings = $$v
                                                },
                                                expression: "coWelcomings"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "form-section xs12 pl-3",
              class: [_vm.coIsAppointment ? "md4" : "md6"]
            },
            [
              _c(
                "div",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-flex",
                    [
                      _c("v-layout", { staticClass: "title--text-custom" }, [
                        _c(
                          "div",
                          {
                            staticClass: "primary--text",
                            domProps: {
                              textContent: _vm._s(
                                _vm.coIsAppointment ? "2" : "1"
                              )
                            }
                          },
                          [_vm._v("2")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "secondary--text" }, [
                          _vm._v(".")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "primary--text" }, [
                        _vm._v("Quoi ?")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.self
                    ? [
                        _c(
                          "v-layout",
                          { staticClass: "mt-3 mb-3", attrs: { row: "" } },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs6: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      disabled:
                                        _vm.isUpdating ||
                                        _vm.canCreateAppointment,
                                      round: "",
                                      outline: !_vm.coIsAppointment
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.handleChangeType(
                                          _vm.typeAppointment
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        style: _vm.getStyleForAppointmentTypeButton(
                                          _vm.typeAppointment
                                        )
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.agendaAppointment
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs6: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "secondary",
                                      disabled:
                                        _vm.isUpdating || _vm.canCreateEvent,
                                      round: "",
                                      outline: _vm.coIsAppointment
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.handleChangeType(_vm.typeEvent)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        style: _vm.getStyleForAppointmentTypeButton(
                                          _vm.typeEvent
                                        )
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(_vm.lblSetting.agendaEvent)
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.coIsAppointment
                    ? _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            required: "",
                            label: _vm.$t(_vm.lblSetting.agendaSidebarBlock)
                          }
                        },
                        [
                          _c("base-multi-select", {
                            attrs: {
                              options: _vm.coBlockOptions,
                              "item-value": "id",
                              icon: "icon icon-blocks",
                              "item-text": "name",
                              "return-object": false,
                              multiple: false,
                              rules: _vm.dtRules.blockRules,
                              fetch: _vm.handleGetBlocks
                            },
                            model: {
                              value: _vm.appointmentFkBlock,
                              callback: function($$v) {
                                _vm.appointmentFkBlock = $$v
                              },
                              expression: "appointmentFkBlock"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.$t(_vm.lblSetting.agendaName)
                      }
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "pt-0",
                        attrs: {
                          counter: _vm.textConfigs.input,
                          maxlength: _vm.textConfigs.input,
                          placeholder: _vm.$t(
                            _vm.lblSetting.agendaTitlePlaceholder
                          ),
                          rules: _vm.dtRules.nameRules,
                          solo: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.appointmentName,
                          callback: function($$v) {
                            _vm.appointmentName = $$v
                          },
                          expression: "appointmentName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.coIsAppointment
                    ? _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            label: _vm.$t(_vm.lblSetting.lblDescription)
                          }
                        },
                        [
                          _c("v-textarea", {
                            staticClass: "pt-0",
                            attrs: {
                              color: "primary",
                              counter: _vm.textConfigs.textarea,
                              maxlength: _vm.textConfigs.textarea,
                              name: "appointment-description white",
                              "auto-grow": "",
                              solo: ""
                            },
                            model: {
                              value: _vm.appointmentDescription,
                              callback: function($$v) {
                                _vm.appointmentDescription = $$v
                              },
                              expression: "appointmentDescription"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "form-section xs12 pl-3",
              class: [_vm.coIsAppointment ? "md4" : "md6"]
            },
            [
              _vm.calendarVisible
                ? _c(
                    "div",
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-layout",
                            { staticClass: "title--text-custom" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "primary--text",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.coIsAppointment ? "3" : "2"
                                    )
                                  }
                                },
                                [_vm._v("3")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "secondary--text" }, [
                                _vm._v(".")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h2", { staticClass: "primary--text" }, [
                            _vm._v("Quand ?")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            xs4: "",
                            label:
                              _vm.$t(_vm.lblSetting.agendaStart) +
                              " - " +
                              _vm.$t(_vm.lblSetting.agendaEnd)
                          }
                        },
                        [
                          _c("base-datetime-picker-range-vertical", {
                            attrs: { step: _vm.dtStep },
                            model: {
                              value: _vm.coDates,
                              callback: function($$v) {
                                _vm.coDates = $$v
                              },
                              expression: "coDates"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("default")
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-layout",
                            { staticClass: "title--text-custom" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "primary--text",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.coIsAppointment ? "3" : "2"
                                    )
                                  }
                                },
                                [_vm._v("3")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "secondary--text" }, [
                                _vm._v(".")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h1", { staticClass: "primary--text" }, [
                            _vm._v("Quand ?")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            xs4: "",
                            label:
                              _vm.$t(_vm.lblSetting.agendaStart) +
                              " - " +
                              _vm.$t(_vm.lblSetting.agendaEnd)
                          }
                        },
                        [
                          _c("base-datetime-picker-range-vertical", {
                            attrs: { step: _vm.dtStep },
                            model: {
                              value: _vm.coDates,
                              callback: function($$v) {
                                _vm.coDates = $$v
                              },
                              expression: "coDates"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1989d629", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1989d629","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/agenda/components/agenda-modal-vertical/template.html
// module id = null
// module chunks = 